export default __webpack_public_path__ + "static/about-us-dylan-3c87c0d036383e9f7895c3f46d1b5422.webp";